<div *ngIf="efateSetupPk && !isLoadingSaved">
  <div class="ef-reports-status flex align-items-center justify-content-between mt-3">
    <span>{{ runStatusLabel }} &nbsp; <strong>{{ statusName }}</strong> &nbsp;
      <p-badge styleClass="{{ badgeStyle }}"></p-badge>
    </span>
    <app-button [label]="runButtonLabel" [disabled]="isLoading" (onClickEvent)="onRunClick()"></app-button>
  </div>
  <ag-grid-angular *ngIf="columnDefs.length" class="ag-theme-alpine ef-reports-grid mt-3" style="width: 100%;"
    [domLayout]="'autoHeight'" [columnDefs]="columnDefs" [rowData]="rowData" [defaultColDef]="defaultColDef"
    [rowHeight]="rowHeight" [headerHeight]="headerHeight" [groupHeaderHeight]="groupHeaderHeight"
    [suppressMovableColumns]="true" [suppressCellFocus]="true">
  </ag-grid-angular>
</div>

<app-loading class="mt-2 flex align-items-center justify-content-center" *ngIf="isLoadingSaved"></app-loading>